import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterStateSnapshot } from '@angular/router';
import { env } from 'process';
import { map, take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/account/auth.service';
import { DupesService } from 'src/app/shared/services/dupes.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { InvitationsService } from 'src/app/shared/services/invitations.service';
import { TenantService } from 'src/app/tenant/tenant.service';
import { environment } from 'src/environments/environment';
import { User } from '../account/user.model';
import { cmsComponent, cmsComponentExtra, cmsRow } from 'src/app/shared/models/cms-component.model';
import { cmsService } from 'src/app/shared/services/cms.service';
import { SSL_OP_NO_TLSv1_1 } from 'constants';
import { SelectServiceService } from 'src/app/shared/services/select-service.service';
import { ServiceGroup } from 'src/app/shared/models/service-group.model';
import { ServiceVenue } from 'src/app/shared/models/service-venue.model';
import { AppService } from 'src/app/shared/services/app.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
  isLoading: boolean = true;
  isDupeLoading: boolean = true;
  isInviteLoading: boolean = true;
  inviteComplete: boolean = false;
  componentLoading: boolean = true;
  componentComplete: boolean = false;
  dupeComplete: boolean = false; 
  serviceUnavailable: boolean = false;
  showNotice: boolean = false;
  public isMenuCollapsed = true;
  public userName: string = null;
  user: User = null;
  private churchName: string = null;
  isDiocese: boolean = false;
  cmsModule: boolean = false;
  cmsComponents: cmsComponent[] = [];
  cmsRows: cmsRow[] = [];
  agreementUrl: string;
  agreementAccepted: boolean = false;
  isFolder: boolean = false;
  myCMS: cmsComponent;
  myExtra: cmsComponentExtra = new cmsComponentExtra();
  groupArr: ServiceGroup[] = [];
  venueArr: ServiceVenue[] = [];  
  message: any;  
  userId: string = '';

  private VAPID_PUBLIC_KEY = 'BBVkoaX4XqfxhuHj-zKyYdZvflOznHpZhj18KOQqcwK28dwsJnkCjFfmwEowK8ZyC0zCzn1xpe7glUm1H4KJndo'


  constructor(
    private authService: AuthService,
    private router: Router,
    private tenantService: TenantService,
    private globalService: GlobalService,
    public identityService: IdentityService,
    private _DupesService: DupesService,
    private _InvitationService: InvitationsService,
    private _cmsService: cmsService,
    private selectService: SelectServiceService,
    private appService: AppService,
    private linkHandler: LinkHandlerService  
  ) { }

  AllowAccess(url: string) {
    if (url.indexOf('resetpassword') >= 0) return true;
    if (url.indexOf('validate') >= 0) return true; 
    if (url.indexOf('formrender') >= 0) return true;
    if (url.indexOf('idcardlookup') >= 0) return true;
    if (url.indexOf('idcard') >= 0) return true;
    if (url.indexOf('signup') >= 0) return true;
    if (url.indexOf('fast-checkin') >= 0) return true;
    if (url.indexOf('unsubscribe') >= 0) return true;
    if (url.indexOf('qr-self-checkin') >= 0) return true;
    if (url.indexOf('qr-self-checkin-fixed') >= 0) return true;
        if (url.indexOf('qr-self-checkin-group') >= 0) return true;
            if (url.indexOf('qr-self-checkin-venu') >= 0) return true;
    if (url.indexOf('add-point') >= 0) return true;
    return false;
  }

  AcceptAgreement(check: any) {
    this.agreementAccepted = check;
  } 

  getUrl(roles: string[]) {
    let Url = '';     
    if (roles == null)
      return '/home';
    if (this.identityService.permissions == null) return;
    if (
      this.identityService.permissions.indexOf('Birthday') >= 0 ||
      this.identityService.permissions.indexOf('Form Admin') >= 0 ||
      this.identityService.permissions.indexOf('Notes Limited Access') >= 0 ||
      this.identityService.permissions.indexOf('Notes Full Access') >= 0 ||
      this.identityService.permissions.indexOf('Admin') >= 0 ||
      this.identityService.permissions.indexOf('Super Admin') >= 0 ||
      this.identityService.permissions.indexOf('Group Admin') >= 0 ||
      this.identityService.permissions.indexOf('Leader') >= 0 ||
      this.identityService.permissions.indexOf('Profile Viewer') >= 0 ||
      this.identityService.permissions.indexOf('Profile Editor') >= 0 ||
      this.identityService.permissions.indexOf('CMS Administrator') >= 0 ||
      this.identityService.permissions.indexOf('Event Organizer') >= 0 ||
      this.identityService.permissions.indexOf('Event Viewer') >= 0 ||
      this.identityService.permissions.indexOf('Attendance Viewer') >= 0 ||
      this.identityService.permissions.indexOf('Membership Requests') >= 0 ||
      this.identityService.permissions.indexOf('Membership Management') >= 0 ||
      this.identityService.permissions.indexOf('Task Assignment') >= 0 ||
      this.identityService.permissions.indexOf('Communication') >= 0 ||
      this.identityService.permissions.indexOf('Giving') >= 0
    ) {
      Url = '/admin/admin-setup';
      return Url;
    }

    if (
      this.identityService.permissions.indexOf('Check-in') >= 0
    ) {
      this.globalService.consentDataPrivacy = true;
      localStorage.setItem('consent', 'true');
      Url = '/usher/check-in';
      return Url;
    }

    if (
      this.identityService.permissions.indexOf('Base') >= 0
    ) {
      this.globalService.consentDataPrivacy = true;
      localStorage.setItem('consent', 'true');
      Url = '/admin/admin-setup';
      return Url;
    }

    this.globalService.consentDataPrivacy = true;
    localStorage.setItem('consent', 'true');
    return '/myprofile';
  }

  RefreshLoading() {
    if (this.isDupeLoading == true || this.isInviteLoading == true || this.componentLoading == true)
      this.isLoading = true;
    else this.isLoading = false;
  }

  RefreshComplete() {
    if (this.inviteComplete && this.dupeComplete && this.componentComplete) this.Proceed();
  }

  OnDupeLoadingComplete() {
    this.isDupeLoading = false;
    this.RefreshLoading();
  }

  OnDupesComplete() {
    this.isDupeLoading = false;
    this.RefreshLoading();
    this.dupeComplete = true;
    this.RefreshComplete();
  }

  OnInviteLoadingComplete() {
    this.isInviteLoading = false;
    this.RefreshLoading();
  } 


  OnInvitesComplete() {
    this.isInviteLoading = false;
    this.RefreshLoading();
    this.inviteComplete = true;
    this.RefreshComplete();
  } 

  OnComponentComplete() {
    this.componentLoading = false;
    this.RefreshLoading();
    this.componentComplete = true;
    this.RefreshComplete();
  }

  SetIdentity() {
    let userId = localStorage.getItem('CSBarcodeID');
    let tenantId = localStorage.getItem('tenant');
      this.appService.sendToNative(userId, tenantId);
  }

  async ngOnInit(): Promise<void> {
    // this.SetIdentity();
    // this.globalService.isBack = true;
    this.globalService.selectedOption = "HOME";    
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader= "";
    this.isLoading = true;
    this.showNotice = true; 
    this.isMenuCollapsed = true;
    var tenantData = await this.tenantService.getSimpleTenant();
    this.agreementUrl = tenantData.agreementUrl;
    this.cmsModule = tenantData.cmsModule;
    this.userId = localStorage.getItem('CSBarcodeID'); 

    if (tenantData.deleted == true) {
          this.serviceUnavailable = true;
          this.router.navigate(['/service-notfound']);
    }            

    if (this.cmsModule == false) {
      this.OnComponentComplete();
      this.user = await this.authService.autoLogin(1);
      if (this.user == null) {
        if (this.userId != null)
          this.appService.sendToNative(this.userId, tenantData.subdomain);
        else
          this.appService.sendToNative("", tenantData.subdomain);
        this.router.navigate([this.globalService.subdomain + '/login']);
      }
      else {
        this.userName = this.user.firstName;
        await this.identityService.loadUser(this.user);  
        this.isDiocese = tenantData.isDiocese;
        this.appService.sendToNative(this.user.id, tenantData.subdomain);
        this.router.navigate(['/admin/admin-setup']);
      }
    }
    else {
      this.cmsComponents = await this._cmsService.loadComponents();
      this.generateRows();  
      this.user = await this.authService.silentLogin(0);
      if (this.user != null) {
        this.userName = this.user.firstName;  
        await this.identityService.loadUser(this.user);
        this.appService.sendToNative(this.user.id, tenantData.subdomain);
        this.isLoading = false;
      }
      else
      {
        if (this.userId != null)
          this.appService.sendToNative(this.userId, tenantData.subdomain);
        else
          this.appService.sendToNative("", tenantData.subdomain);
      }

      setTimeout(() => { 
        this.OnComponentComplete();
        this.isLoading = false;
      }, 1000);   
    }
  }

  generateRows() {
    this.cmsRows = [];

    let i = 0;

    this.cmsComponents.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      else return 1;
    });

    while (i < this.cmsComponents.length) {
      if (this.cmsComponents[i].isActive == false || (this.cmsComponents[i].visibility == 1 && this.globalService.currentLanguage == "Arabic") 
        || (this.cmsComponents[i].visibility == 2 && this.globalService.currentLanguage == "English")) {
        i = this.getNextActive(i);
        continue;
      }
      let curCmsRow: cmsRow = new cmsRow();
      curCmsRow.component1 = null;
      curCmsRow.component2 = null;

      if (this.cmsComponents[i].size == 2) {
        curCmsRow.component1 = this.cmsComponents[i]; 
        curCmsRow.component2 = null;
        this.cmsRows.push(curCmsRow);
        i = this.getNextActive(i);
        continue;
      }

      let j = this.getNextActive(i);

      if ((j < this.cmsComponents.length) && (this.cmsComponents[i].size == 1 && this.cmsComponents[j].size == 1)) {
        curCmsRow.component1 = this.cmsComponents[i];
        curCmsRow.component2 = this.cmsComponents[j];
        this.cmsRows.push(curCmsRow);
        i = this.getNextActive(j);
        continue;
      }

      if (this.cmsComponents[i].size == 1) {
        curCmsRow.component1 = this.cmsComponents[i];
        curCmsRow.component2 = null;
        this.cmsRows.push(curCmsRow);
        i = j;
        continue;
      }
    }
  }
  getNextActive(i) {
    i = i + 1;
    while (i < this.cmsComponents.length && (this.cmsComponents[i].isActive == false 
      || (this.cmsComponents[i].visibility == 1 && this.globalService.currentLanguage == "Arabic") 
      || (this.cmsComponents[i].visibility == 2 && this.globalService.currentLanguage == "English")))
      i = i + 1;
    if (i < this.cmsComponents.length && this.cmsComponents[i].isActive == true &&  (this.cmsComponents[i].visibility == 0 
      || (this.cmsComponents[i].visibility == 1 && this.globalService.currentLanguage == "English") 
      || (this.cmsComponents[i].visibility == 2 && this.globalService.currentLanguage == "Arabic")))
      return i;
    return this.cmsComponents.length;
  }

  async noticesExist(): Promise<boolean> {
    var dupes = await this._DupesService.getDupes(this.globalService.currentUserId);
    if (dupes.length > 0) return true;
    var invitations = await this._InvitationService.getInvitations(
      this.globalService.currentUserId,
      false
    );
    if (invitations.length > 0) return true;
    return false;
  }

  async Proceed() {
    this.showNotice = false;
    if (this.user == null)
      {
        this.isLoading = false;
        return;
      }
    let Url = this.getUrl(this.user?.roles);
    this.router.navigate([Url]);
    this.globalService.Initialize();
    this.isLoading = true;
    this.isMenuCollapsed = true;
    this.churchName = await this.tenantService
      .getSimpleTenant()
      .then((x) => {
        if (x.deleted == true) {
          this.serviceUnavailable = true;
          this.router.navigate(['/service-notfound']);
          return '';
        }
        this.isLoading = false;
        return x.name;
      })
      .catch((a) => {
        this.serviceUnavailable = true;
        this.router.navigate(['/service-notfound']);
        return '';
      });

    this.router.events.subscribe(() => {
      this.isMenuCollapsed = true;
    }); 
  }

  OnLogout() {
    this.authService.logout(1);
    this.isMenuCollapsed = true;
    this.router.navigate([this.globalService.subdomain + '/login']);
  }

  async execute(component) {
    window.localStorage.setItem('bodyHeight', `${window.innerHeight}px`);    
    if (component.urlLink != null && component.urlLink != '') {
      if ((component.urlLink.toLowerCase().indexOf('church-services')>=0) ||
      (component.urlLink.toLowerCase().indexOf('localhost')>=0))
      {
        component.isExternal = false;
        component.urlLink = component.urlLink.toLowerCase().replace('http://','').replace('https://','');
        component.urlLink = component.urlLink.substring(component.urlLink.indexOf('/'));

      }
      if (component.isExternal == true)
      {
        //window.open(encodeURI(component.urlLink), '_blank');   
        this.linkHandler.open(component.urlLink) ;
        document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight');        
      }
      else
      {
        if (component.urlLink.indexOf('calendar')>=0)
        {
          var urlElements = component.urlLink.split('/');
          var cmsID = urlElements[3];
          var folderID = urlElements[4];
          this.isFolder = folderID != '0';
          this.myCMS = await this._cmsService.loadComponent(cmsID);
          this.reset();
          if (this.isFolder == false)
            await this.loadDetails(cmsID, false); 
          else
            await this.loadDetails(folderID, true);  
      
      
          if (this.myExtra.allowRSVP == true && this.myExtra.calendarService == 0 && this.myExtra.calendarLocation == 0)
          {
            this.router.navigate([this.globalService.subdomain + '/member/select-service/1']);
            document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight');        
            return;
          }
      
          await this.LoadServiceVenue();
      
          if (this.myExtra.allowRSVP == true)
          {
            let service = this.myExtra.calendarService == 0? 'All': this.groupArr.find(a => a.id == this.myExtra.calendarService).name.replace(' ', '_');
            let location = this.myExtra.calendarLocation == 0? 'All': this.venueArr.find(a => a.id == this.myExtra.calendarLocation).name.replace(' ', '_');
            this.router.navigate([this.globalService.subdomain + '/member/select-service/1/' + service + '/' + location]);    
            document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight');        
            return;  
          }      
          else
          {
            this.router.navigate([component.urlLink]);
            document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight');        

          }
        }
        this.router.navigate([component.urlLink]);
        document.getElementsByTagName('body')[0].style.minHeight = window.localStorage.getItem('bodyHeight');        
      }
    }
  } 

  reset() {
    this.myExtra.componentId = this.isFolder == false ? this.myCMS.id : 0;
    this.myExtra.folderId = this.isFolder == true ? this.myCMS.id : 0;
    this.myExtra.street = "";
    this.myExtra.city = "";
    this.myExtra.state = "";
    this.myExtra.zip = "";
    this.myExtra.calendarService = 0;
    this.myExtra.calendarLocation = 0;
    this.myExtra.directURL = "";
  }

  async LoadServiceVenue() {
    this.groupArr = await this.selectService.getActiveGroups();
    this.venueArr = await this.selectService.getActiveVenues();
  }

  async loadDetails(id, isFolder) {
    let result = await this._cmsService.loadExtra(id, isFolder);
    if (result != null) this.myExtra = result;
  }

  getTitle(rowComponent) { 
    if (rowComponent == null)
      return '';
    if (rowComponent.title2 == '')
      return rowComponent.title;
    let ret = this.globalService.isRTL == true? rowComponent.title2: rowComponent.title;
    return ret;
  }
  
  openConfigure() { 
    this.globalService.consentDataPrivacy = true;
    localStorage.setItem('consent','true');      
    this.router.navigate(['/admin/cms']);    
  }
}
  